import { ISeoMetaData } from '.'

export const preventiveServicesSeoMetaData: ISeoMetaData[] = [
  {
    path: '/preventive-services',
    component: 'Preventive Services',
    seo: {
      en: {
        title: 'My preventive services | Medicare',
        description: ''
      },
      es: {
        title: 'Mis servicios preventivos | Medicare',
        description: ''
      }
    }
  },
  {
    path: '/preventive-services/available',
    component: 'Preventive Services',
    seo: {
      en: {
        title: 'My preventive services | Medicare',
        description: ''
      },
      es: {
        title: 'Mis servicios preventivos | Medicare',
        description: ''
      }
    }
  },
  {
    path: '/preventive-services/upcoming',
    component: 'Preventive Services',
    seo: {
      en: {
        title: 'My preventive services | Medicare',
        description: ''
      },
      es: {
        title: 'Mis servicios preventivos | Medicare',
        description: ''
      }
    }
  }
].map(seoMetaData => ({
  ...seoMetaData,
  component: 'Preventive Services'
}))
